import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ClientService } from '../../../services/client.service';

@Component({
  selector: 'app-contact',
  standalone: false,
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  contacts: any[] = [];
  clientId = '';
  loading = false;
  errorMessage = '';

  constructor(
    private clientService: ClientService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.parent?.paramMap.subscribe(params => {
      this.clientId = params.get('clientId') || '';
      if (this.clientId) {
        this.loadContacts();
      }
    });
  }

  loadContacts(): void {
    this.loading = true;
    this.errorMessage = '';
    this.contacts = [];

    this.clientService.getContacts(this.clientId).subscribe({
      next: (data) => {
        if (data && data.length > 0) {
          this.contacts = data;
        } else {
          this.contacts = [];
          this.errorMessage = 'No contacts found';
        }
        this.loading = false;
      },
      error: () => {
        this.errorMessage = 'Unable to load contact details at this time.';
        this.loading = false;
      }
    });
  }

  formatPhoneNumber(phone: string): string {
    if (!phone) return '';

    const cleaned = phone.replace(/\D/g, '');

    if (cleaned.length === 10) {
      return `${cleaned.substring(0, 3)}-${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
    }

    return phone; // fallback
}
}
